module.exports = __webpack_public_path__ + "img/default_course.26d0d121.png";